module.exports = __webpack_public_path__ + "img/logo_grey.f6e04fb9.svg";